import React from 'react';
import PropTypes from 'prop-types';
import Message from 'Components/Modal/Message';
import Icon from 'Components/Icon';
import EnvironmentManager from 'Utils/environmentManager';

const MultiplePlayFailure = props => {
  const { couponCount } = props;

  const buttonConfig = {
    primary: {
      label: EnvironmentManager.getMessageText({ key: 'button_go_bulletin' }) || 'BÜLTENE GİT',
      onClick: props.onPrimaryButtonClick
    }
  };
  const errMessage = EnvironmentManager.getMessageText({ key: 'multi_coupon_failed' }) || 'tane kuponun zaman aşımı veya teknik bir hata sebebiyle oynanamadı.';
  return (
    <Message type="none" buttonConfig={ buttonConfig } >
      <p className="multiple-play-failure-modal">
        <Icon iconName='svgIconFailed' />
        <strong>{ couponCount }</strong> { errMessage }
      </p>
    </Message>
  );
};

MultiplePlayFailure.propTypes = {
  onPrimaryButtonClick: PropTypes.func.isRequired,
  couponCount: PropTypes.number
};

export default MultiplePlayFailure;
